import { compile } from '@/core/index'
import Api from './Api'

const tableUtil = {
  box(fields, settings) {
    const arrC = []
    const arrH = []
    let left = 0
    let right = 0
    let wa = 0
    fields.forEach(opt => {
      const { width, label, fixed, field } = opt
      const w = Number(width) || 150
      const co = `<col width="${w}">`
      let hrt = `
      <th colspan="1" rowspan="1" name="${field}" class="is-leaf">
        <div class="cell">${label || ''}</div>
      </th>`
      if (field === 'selection') {
        this._check = true
        if (settings.multable) {
          hrt = `
          <th colspan="1" rowspan="1" name="${field}" class="is-leaf table-column--selection table-header--selection">
            <div class="cell">
              <label class="lt-checkbox">
                <span class="checkbox__input">
                  <span class="checkbox__inner"></span>
                  </span>
              </label>
            </div>
          </th>`
        } else {
          hrt = `
          <th colspan="1" rowspan="1" name="${field}" class="is-leaf">
            <div class="cell">选择</div>
          </th>`
        }
      }
      arrC.push(co)
      arrH.push(hrt)
      wa += w
      if (fixed === 'left') left += w
      else if (fixed === 'right') right += w
    })
    const col = arrC.join('')
    const hr = arrH.join('')
    return { col, hr, wa, left, right }
  },
  shell(opt) {
    const {
      hover,
      border,
      stripe,
      height,
      highest,
      col,
      hr,
      wa,
      cellNoWrap,
    } = opt
    const unit = $(`
    <div class="lt-table table--fit table--enable-row-hover table--scrollable-y table--enable-row-transition" style="width: 100%;">
      <div class="table__header-wrapper">
        <table cellspacing="0" cellpadding="0" border="0" class="table__header" style="width: ${
          wa + 17
        }px;">
          <colgroup>
            ${col}
            <col name="gutter" width="0">
          </colgroup>
          <thead class="has-gutter">
            <tr>
              ${hr}
              <th class="gutter" style="width: 0px; display: none;"></th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table__body-wrapper is-scrolling-none">
        <table cellspacing="0" cellpadding="0" border="0" class="table__body" style="width: ${wa}px;">
          <colgroup>
           ${col}
          </colgroup>
          <tbody>
          </tbody>
        </table>
      </div>
      <div class="table__column-resize-proxy" style="display: none;"></div>
    </div>`)
    if (String(hover) === 'true') {
      unit
        .addClass('table--enable-row-hover')
        .addClass('table--enable-row-transition')
    }
    if (String(border) === 'true') unit.addClass('table--border')
    if (String(stripe) === 'true') unit.addClass('table--striped')
    if (Number(height) || Number(highest)) unit.addClass('table--scrollable-y')
    if (String(cellNoWrap) === 'true') unit.addClass('table--cell-no-warp')
    const gc = unit.find('col[name=gutter]')
    const gt = unit.find('.gutter')
    const empty = $(`
    <div class="table__empty-block" style="height: 100%; width: 100%;">
      <span class="table__empty-text">暂无数据</span>
    </div>`)
    const mask = $(`
    <div class="loading-mask" >
      <div class="loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>`)
    return { unit, gc, gt, empty, mask }
  },
}

export default class Table extends Api {
  constructor(el, opt) {
    super(el, opt)
    this.init()
  }

  init() {
    const el = this.$el
    if (!el) {
      return console.error(`${el}不存在!初始化前,确认此选择器是否已挂载.`)
    }
    const temp = compile.read(el)
    if (!temp) return console.error(`${el}不存在的模板!`)
    const { fields, navs, ins } = compile.cell(temp)
    Object.assign(this.settings, { fields, navs, ins })
    this.temp = temp
    this.box = tableUtil.box(fields, this.settings)
    this.render()
  }

  currentChange(fn) {
    this._currentChange = fn
  }

  tabsSize() {
    let self
    const tables = this.unit.find('.table__header-wrapper .table__header')
    Array.from(tables).forEach(table => {
      const header = table.rows[0]
      let tableX = header.clientWidth
      const cells = $(table).find('th')
      Array.from(cells).forEach((item, i) => {
        item.onmousedown = event => {
          self = item
          if (event.offsetX > self.offsetWidth - 10) {
            self.mouseDown = true
            self.oldX = event.x
            self.oldWidth = self.offsetWidth
          }
        }
        item.onmousemove = event => {
          const target = item
          if (event.offsetX > target.offsetWidth - 10) {
            target.style.cursor = 'col-resize'
          } else {
            target.style.cursor = 'default'
          }
          self || (self = target)
          if (self.mouseDown != null && self.mouseDown === true) {
            self.style.cursor = 'default'
            let width
            if (self.oldWidth + (event.x - self.oldX) > 0) {
              width = self.oldWidth + (event.x - self.oldX)
            }
            const num = $(self).parent().children().index($(self))
            const cols = this.unit.find(`colgroup col:nth-child(${num + 1})`)
            cols.attr('width', width)
            self.style.cursor = 'col-resize'
            this.trimFinal()
          }
        }
        item.onmouseup = event => {
          self || (self = event.target)
          self.mouseDown = false
          self.style.cursor = 'default'
          tableX = header.clientWidth
        }
      })
    })
  }

  render() {
    const el = this.$el
    el.css({ display: 'flex', 'flex-flow': 'column' })
    const opt = {}
    Object.assign(opt, this.box, this.settings)
    const { unit, gc, gt, empty, mask } = tableUtil.shell(opt)
    el.append(unit)
    Object.assign(this.box, { gc, gt })
    Object.assign(this, { unit, empty, mask })
  }

  update() {
    this.loading = false
    this.checked = false
    const { unit } = this
    this.empty.detach()
    unit.find('.table__fixed,.table__fixed-right').remove()
    unit.find('tbody').empty()
    const { data = [] } = this.settings
    const { gc, gt } = this.box
    const div = $('<div></div>')
    data.forEach((item, index) => {
      const obj = this.renderRows({ item, index })
      div.append(obj)
    })
    const tbody = unit.find('tbody')
    tbody.html(div.children())
    data.length || unit.find('.table__body').after(this.empty)
    gc.detach()
    gt.detach()
    this.trimFixed()
    this.trimFinal()
    this.tabsSize()
    const hd = unit.find('.table__header-wrapper')
    const tb = unit.find('.table__body-wrapper')
    hd.find('colgroup').append(gc)
    hd.find('tr').append(gt)
    const { highlightCurrentRow, multable } = this.settings
    const tth = unit
      .find('.table-header--selection .checkbox__input')
      .removeClass('is-checked')
      .removeClass('is-indeterminate')
    // 单选/多选事件
    this.$el.unbind('click').bind('click', e => {
      if (multable) {
        const tr = $(e.target).closest('.table__row')
        const th = $(e.target).closest('.table-header--selection')
        if (th.length > 0) {
          const trs = unit.find('.table__row')
          const ths = unit.find('.table-header--selection')
          if (Object.keys(this.checkedRow).length === data.length) {
            this.checkedRow = {}
            ths
              .find('.checkbox__input')
              .removeClass('is-checked')
              .removeClass('is-indeterminate')
            trs.removeClass('current-row')
            trs
              .find('.table-column--selection .checkbox__input')
              .removeClass('is-checked')
          } else {
            data.map((item, i) => {
              this.checkedRow[i] = item
            })
            ths
              .find('.checkbox__input')
              .addClass('is-checked')
              .removeClass('is-indeterminate')
            trs.addClass('current-row')
            trs
              .find('.table-column--selection .checkbox__input')
              .addClass('is-checked')
          }
          if ($.type(this._checkedChange) === 'function') {
            this._checkedChange(
              this.checkedRow,
              Object.keys(this.checkedRow),
              Object.values(this.checkedRow)
            )
          }
        } else if (tr.length > 0) {
          const name = tr.attr('name')
          const trs = unit.find('.table__row')
          const ths = unit.find('.table-header--selection')
          trs.removeClass('current-row')
          trs
            .find('.table-column--selection .checkbox__input')
            .removeClass('is-checked')
          if (name.length > 4) {
            const index = Number(name.substring(4))
            const dd = data[index]
            const checks = this.checkedRow
            if (Object.prototype.hasOwnProperty.call(checks, index)) {
              delete checks[index]
            } else {
              checks[index] = dd
            }
            Object.keys(checks).map(index => {
              unit
                .find(`[name=row_${index}]`)
                .find('.table-column--selection .checkbox__input')
                .addClass('is-checked')
              unit.find(`[name=row_${index}]`).addClass('current-row')
            })
            if (Object.keys(checks).length === data.length) {
              this.checked = true
              ths
                .find('.checkbox__input')
                .addClass('is-checked')
                .removeClass('is-indeterminate')
            } else if (Object.keys(checks).length > 0) {
              this.checked = true
              ths
                .find('.checkbox__input')
                .removeClass('is-checked')
                .addClass('is-indeterminate')
            } else {
              this.checked = false
              ths
                .find('.checkbox__input')
                .removeClass('is-checked')
                .removeClass('is-indeterminate')
            }
            if ($.type(this._currentChange) === 'function') {
              this._currentChange(dd, index)
            }
            if ($.type(this._checkedChange) === 'function') {
              this._checkedChange(
                checks,
                Object.keys(checks),
                Object.values(checks)
              )
            }
          }
        }
      } else if (highlightCurrentRow) {
        const tr = $(e.target).closest('.table__row')
        if (tr.length > 0) {
          const name = tr.attr('name')
          const trs = unit.find('.table__row')
          trs.removeClass('current-row')
          trs
            .find('.table-column--selection .lt-checkbox')
            .removeClass('is-checked')
          trs
            .find('.table-column--selection .checkbox__input')
            .removeClass('is-checked')
          if (name.length > 4) {
            const index = Number(name.substring(4))
            const dd = data[index]
            unit
              .find(`[name=${name}]`)
              .find('.table-column--selection .lt-checkbox')
              .addClass('is-checked')
            unit
              .find(`[name=${name}]`)
              .find('.table-column--selection .checkbox__input')
              .addClass('is-checked')
            unit.find(`[name=${name}]`).addClass('current-row')
            this.checked = true
            this.checkedRow.data = dd
            if ($.type(this._currentChange) === 'function') {
              this._currentChange(dd, index)
            }
          }
        }
      }
    })
    // 表格悬浮行变色
    const tr = unit.find('.table__row')
    tr.hover(e => {
      const tar = $(e.target).closest('tr')
      tr.removeClass('hover-row')
      const name = tar.attr('name')
      unit.find(`[name=${name}]`).addClass('hover-row')
    })
    const fr = unit.find('.table__fixed-body-wrapper')
    tb.scrollTop(0).scrollLeft(0).addClass('is-scrolling-left')
    const son = { tb, hd, fr }
    // 主表滚动事件
    tb.unbind('scroll', this.mainTableScroll).scroll(
      $.proxy(this.mainTableScroll, this, son)
    )
    $(window).resize(() => {
      this.trimFinal()
    })
  }

  mainTableScroll(son, e) {
    const { tb, hd, fr } = son
    const wt = tb.find('table').width()
    const wf = tb.width()
    const tbh = tb.scrollTop()
    const tbl = tb.scrollLeft()
    hd.scrollLeft(tbl)
    fr.scrollTop(tbh)
    tb.removeClass('is-scrolling-left is-scrolling-right')
    if (tbl + wf >= wt) {
      tb.addClass('is-scrolling-right')
    } else if (tbl === 0) {
      tb.addClass('is-scrolling-left')
    }
  }

  trimFixed() {
    const { left, right } = this.box
    const { unit } = this
    const proxy = unit.find('.table__column-resize-proxy')
    const tableHeader = unit.find('.table__header-wrapper')
    const tableBody = unit.find('.table__body-wrapper')
    unit.find('td').removeClass('is-hidden')
    const header = tableHeader
      .clone()
      .removeClass()
      .addClass('table__fixed-header-wrapper')
    const body = tableBody
      .clone()
      .removeClass()
      .addClass('table__fixed-body-wrapper')
    if (left > 0) {
      const div = $('<div class="table__fixed"></div>')
      const hd = header.clone()
      const bd = body.clone()
      this.reBind(bd)
      div.append(hd).append(bd).css('width', left)
      proxy.before(div)
    }
    if (right > 0) {
      const div = $('<div class="table__fixed-right"></div>')
      const patch = $('<div class="table__fixed-right-patch" ></div>')
      const hd = header.clone()
      const bd = body.clone()
      this.reBind(bd)
      div.append(hd).append(bd).css('width', right)
      proxy.before(div).before(patch)
    }
  }

  trimFinal() {
    const { height, highest } = this.settings
    const { unit } = this
    const hw = unit.find('.table__header-wrapper')
    const bw = unit.find('.table__body-wrapper')
    const fl = unit.find('.table__fixed')
    const fr = unit.find('.table__fixed-right')
    const fb = unit.find('.table__fixed-body-wrapper')
    const pch = unit.find('.table__fixed-right-patch')
    const ffhw = unit.find('.table__fixed-header-wrapper')
    ffhw.css('width', '')
    const { gc, gt } = this.box
    // table
    const tb = unit.find('table')
    const tb0 = hw.find('table')
    // 表头高度参数--48
    const hh = hw.height()
    // 宽度参数
    const w0 = unit.width()
    const wa = Array.from(hw.find('col')).reduce((total, col) => {
      return total + $(col).attr('width') * 1 || 0
    }, 0)
    // 高度参数
    const he = Number(height) || Number(highest) || 0
    const h0 = $(window).height() - Number(he)
    const h1 = h0 - hh
    const ha = unit.find('.table__body-wrapper table').height()
    fb.css({ top: hh })
    // 高度比较
    if (ha < h1 || (!Number(highest) && !Number(height))) {
      // 没有右侧滚动条
      tb.width(wa)
      this.empty.width(wa)
      pch.css({ height: 0, width: 0 })
      gt.css({ display: 'none', width: 0 })
      gc.attr('width', 0)
    } else {
      // 有右侧滚动条
      tb.width(wa - 17)
      this.empty.width(wa - 17)
      tb0.width(wa)
      pch.css({ height: hh, width: 17 })
      fr.css({ right: 17 })
      gc.attr('width', 17)
      gt.css({ display: '', width: 17 })
    }
    // 宽度比较
    if (wa < w0) {
      // 无底侧滚动条
      bw.addClass('is-scrolling-none')
      unit.removeClass('table--scrollable-x')
      fl.css({ bottom: 0, display: 'none' })
      fr.css({ bottom: 0, display: 'none' })
      tb.width('100%')
      tb0.width('100%')
      this.empty.width('100%')
      gc.css('display', 'none')
      gt.css('display', 'none')
      if (ha < h1 || (!Number(highest) && !Number(height))) {
        hw.css({ width: '100%' })
      } else {
        hw.css({ width: 'calc(100% - 17px)' })
      }
    } else {
      // 有底侧滚动条
      bw.removeClass('is-scrolling-none')
      unit.addClass('table--scrollable-x')
      fl.css({ bottom: 17, display: '' })
      fr.css({ bottom: 17, display: '' })
      gc.css('display', '')
      gt.css('display', '')
      hw.css({ width: '100%' })
    }
    // 高度和流体高度
    if (Number(height)) {
      unit.css({ height: h0 })
      bw.css({ height: h1 })
      if (wa < w0) {
        fb.css({ height: h1 })
      } else {
        fb.css({ height: h1 - 17 })
      }
    }
    if (Number(highest)) {
      unit.css({ 'max-height': h0 })
      bw.css({ 'max-height': h1 })
      if (wa < w0) {
        fb.css({ 'max-height': h1 })
      } else {
        fb.css({ 'max-height': h1 - 17 })
      }
    }

    // 调整 title 是否出现
    const cells = unit.find('.cell')
    Array.from(cells).forEach(cell => {
      const ce = $(cell)
      if (ce.prop('scrollWidth') > ce.outerWidth()) {
        const title = ce.attr('oldtitle')
        title && ce.attr('title', title)
      } else {
        const title = ce.attr('title')
        title && ce.attr('oldtitle', title)
        ce.removeAttr('title')
      }
    })
  }

  reBind(body) {
    const data = this.settings.data
    const fns = this._transColumn
    for (const key in fns) {
      const fn = fns[key]
      const tds = body.find(`td[name=${key}]`)
      Array.from(tds).forEach((td, i) => {
        if ($.type(this._transColumn[key]) === 'function') {
          const div = fn(data[i] || {}, i, $(td), key)
          $(td).find('.cell').html(div)
        }
      })
    }
  }

  renderRows(opt) {
    const { fields, stripe, codeContent, ins } = this.settings
    const { item, index } = opt
    const { unit } = this
    const bt = unit.find('.table__body-wrapper')
    const stripeC =
      String(stripe) === 'true' && index & 1 ? 'table__row--striped' : ''
    const defineRowClass =
      $.type(this._tableRowClassName) === 'function'
        ? this._tableRowClassName(item, index)
        : ''
    const outer = $(
      `<tr name="row_${index}" class="table__row ${stripeC} ${defineRowClass}"></tr>`
    )
    fields.forEach((opt, i) => {
      const inside = ins.filter(x => x.field === opt.field)
      if (inside.length) {
        const td = $(`
        <td rowspan="1" colspan="1" name="${opt.field}">
          <div class="cell"></div>
        </td>`)
        const cell = td.find('.cell')
        Array.from(inside).forEach(x => {
          x.anchor = bt
          x.size = 'mini'
          const obj = compile.unit(x)
          cell.append(obj.unit)
        })
        outer.append(td)
      } else if (opt.field === 'selection') {
        const td = $(`
        <td rowspan="1" colspan="1" name="selection" class="table-column--selection">
          <div class="cell">
            <label class="lt-checkbox">
              <span class="checkbox__input">
                <span class="checkbox__inner"></span>
              </span>
            </label>
          </div>
        </td>`)
        outer.append(td)
      } else if (opt.code) {
        const code = item[opt.field] || ''
        const arr = codeContent[opt.code.trim().toLowerCase()] || []
        let answer = ''
        arr.some(x => {
          if (x.f_code === code) {
            answer = x.f_name
            return true
          }
        })
        const td = $(`
        <td rowspan="1" colspan="1" name="${opt.field}">
          <div class="cell"  title="${answer || ''}">${answer || ''}</div>
        </td>`)
        outer.append(td)
      } else {
        const text =
          item[opt.field] === undefined ? '' : String(item[opt.field])
        const td = $(`
        <td rowspan="1" colspan="1" name="${opt.field}">
          <div class="cell" title="${text}">${text}</div>
        </td>`)
        if ($.type(this._transColumn[opt.field]) === 'function') {
          const div = this._transColumn[opt.field](
            item || {},
            i,
            td,
            opt.field,
            outer
          )
          td.find('.cell').html(div)
        }
        outer.append(td)
      }
    })
    return outer
  }
}
